import { gql } from "@apollo/client";

export const getLoggedInUser = gql`
  query getLoginUser($id: ID!, $companyId: ID!) {
    getUser(id: $id, userCompanyId: $companyId) {
      activatedDate
      eeid
      firstName
      fullName
      aboutMe
      hireDate
      id
      lastName
      department
      designation
      location
      managingDepartment
      reactivatedDate
      role
      sendUserTargetForReview
      deactivatedDate
      createdAt
      status
      totalWeightage
      supervisorId
      companyId
      termsAndConditionsAccepted
      onboarding
      preferredName
      dashboardConfiguration {
        widget
        position
        hidden
        isEnabled
        name
      }
      defaultPermission {
        code
        name
        permissionCategory {
          name
          permission {
            code
            name
            access {
              deleteAccess
              modifyAccess
              readAccess
              writeAccess
            }
          }
        }
      }
      additionalPermission {
        code
        name
        permissionCategory {
          name
          permission {
            access {
              deleteAccess
              modifyAccess
              readAccess
              writeAccess
            }
            code
            name
          }
        }
      }
      supervisor {
        id
        fullName
        firstName
        lastName
        profileImage {
          fileName
        }
      }
      topStrengths {
        sequence
        category
        strength
      }
      profile {
        contactNumber
        email
      }
      profileImage {
        url
        fileName
      }
      banner {
        url
        fileName
      }
      onboardingQuestions {
        question
        answer
        isSelected
        isDefault
        isDeleted
      }
    }
  }
`;

export const getLoggedInUserCompany = gql`
  query getLoggedInUserCompany($id: ID!, $companyId: ID!) {
    getUser(id: $id, userCompanyId: $companyId) {
      id
      company {
        companyId
        createdAt
        tenantId
        name
        acknowledgeOnline
        companyActivationDate
        profile {
          contactNumber
          address {
            address
            city
            state
            zipcode
            country
          }
          links {
            type
            url
          }
          logo {
            key
            url
            uploadUrl
            fileName
          }
          sizeOfOrganization
          reasonOfUsage
          primaryIndustry
          otherReasonOfUsage
        }
        theme
        imprint {
          termsAndConditions {
            version
            latest
            createdAt
            terms
            url
          }
        }
        config {
          passwordPolicy {
            complexity
          }
          departments
          designations
          locations
          setUpMessages {
            loginWelcome
          }
        }
        referenceFeature {
          target {
            color
            type
            name
            isEnabled
            color
          }
          checkin {
            type
            name
            isEnabled
          }
          myTeam
          communication
          library
        }
        feature {
          target {
            color
            type
            name
            isEnabled
          }
          checkin {
            type
            name
            isEnabled
          }
          myTeam
          communication
          library
          createPerformanceReview
          createSuccessStory
        }
        onBoarding
        onboardingQuestions {
          question
          answer
          isSelected
          isDefault
          isDeleted
        }
        performanceCycle {
          items {
            id
            type
            Name
            srNo
            yearStartDate
            yearEndDate
            cycleStartDate
            cycleEndDate
            weightageType
          }
        }
      }
    }
  }
`;

export const userProfileDetail = gql`
  query userProfileDetail($id: ID!, $companyId: ID!) {
    getUser(id: $id, userCompanyId: $companyId) {
      activatedDate
      eeid
      firstName
      fullName
      invitedDate
      preferredName
      aboutMe
      hireDate
      id
      lastName
      department
      designation
      location
      managingDepartment
      reactivatedDate
      role
      sendUserTargetForReview
      deactivatedDate
      createdAt
      status
      totalWeightage
      supervisorId
      companyId
      termsAndConditionsAccepted
      onboarding
      gallupSurveyReport {
        key
        url
        uploadUrl
        fileName
      }
      defaultPermission {
        code
        name
        permissionCategory {
          name
          permission {
            code
            name
            access {
              deleteAccess
              modifyAccess
              readAccess
              writeAccess
            }
          }
        }
      }
      additionalPermission {
        code
        name
        permissionCategory {
          name
          permission {
            access {
              deleteAccess
              modifyAccess
              readAccess
              writeAccess
            }
            code
            name
          }
        }
      }
      supervisor {
        firstName
        lastName
      }
      topStrengths {
        sequence
        category
        strength
      }
      profile {
        contactNumber
        email
      }
      profileImage {
        url
        fileName
      }
      banner {
        url
        fileName
      }
      onboardingQuestions {
        question
        answer
        isSelected
        isDefault
        isDeleted
      }

      userBadges {
        items {
          id
          badge
          assignDate
          comment
          createdAt
          assignedByUser {
            firstName
            lastName
            fullName
            profileImage {
              url
              fileName
            }
          }
        }
      }
    }
  }
`;

export const targetOverviewTaggedSkill = gql`
  query targetOverviewTaggedSkill($id: ID!, $companyId: ID!, $actionType: DashbordActionType) {
    getUser(id: $id, userCompanyId: $companyId) {
      id
      userDashboardReport(actionType: $actionType) {
        taggedSkillToTarget {
          skillName
          taggedTargetCount
          averageRateeScore
        }
      }
    }
  }
`;

export const editUserForm = gql`
  query editUserForm($id: ID!, $companyId: ID!) {
    getUser(id: $id, userCompanyId: $companyId) {
      eeid
      firstName
      hireDate
      id
      lastName
      department
      designation
      location
      managingDepartment
      role
      createdAt
      supervisorId
      status
      topStrengths {
        sequence
        category
        strength
      }
      profile {
        contactNumber
        email
      }
    }
  }
`;

export const checkinUserProfileDetail = gql`
  query checkinUserProfileDetail(
    $id: ID!
    $companyId: ID!
    $checkinListType: CheckinListType
    $checkinSelection: TargetFilterType
  ) {
    getUser(id: $id, userCompanyId: $companyId) {
      id
      listCheckinCustom(
        checkinListType: $checkinListType
        checkinSelection: $checkinSelection
      ) {
        items {
          checkins {
            id
            isNew
            publishPeriod
            userRoleTypeForSRS
            enableViewResponse
            checkinStatusToDisplay
            combinedCheckInTypes
            name
            checkInType
            description
            scheduleFrequency
            frequencyRepeatsOn
            startDate
            endDate
            checkInStatus
            checkinCoachId
            checkInTargetId
            checkinDetails {
              endDate
              isCurrentFrequency
              startDate
              status
              totalAssignedCoachees
              totalCompletedCoachees
              checkinSequenceNo
            }
            userCheckinDetails(userId: $id) {
              endDate
              isCurrentFrequency
              startDate
              status
              id
              checkinSequenceNo
              ratees {
                status
                ratee {
                  userid
                  firstName
                  lastName
                  profileImage {
                    url
                    fileName
                  }
                }
              }
            }
            checkInType
            createdByUserId
            createdBy {
              profileImage {
                url
                fileName
              }
              firstName
              lastName
              fullName
              department
            }
          }
          type
        }
      }
    }
  }
`;
// dashboard target listing

export const targetUserProfileDetail = gql`
  query targetUserProfileDetail(
    $id: ID!
    $companyId: ID!
    $targetListType: TargetListType
    $view: ListTargetView
    $targetSelection: TargetFilterType
    $listFilter: CreateGridFiltersInput
    $nextToken: String
  ) {
    getUser(id: $id, userCompanyId: $companyId) {
      id
      listTargetCustom(
        userId: $id
        targetListType: $targetListType
        view: $view
        listFilter: $listFilter
        targetSelection: $targetSelection
        nextToken: $nextToken
      ) {
        items {
          type
          targets {
            primaryCoachId
            completionApprovalRequest
            completionApprovalRequired
            isNew
            targetMessageCount
            targetAttachmentsCount
            objectivesCount
            random
            # description
            # weightage
            # assignToMe
            # targetApprovalType
            logo {
              url
              fileName
            }
            #people {
            #  id
            #  role
            #  leadReviewer
            #  appointedAsCreator
            #  user {
            #    firstName
            #    lastName
            #    department
            #    designation
            #    role
            #    profileImage {
            #      fileName
            #    }
            #    supervisor {
            #      id
            #      fullName
            #      firstName
            #      lastName
            #      profileImage {
            #        fileName
            #      }
            #    }
            #  }
            #}
            # reviewProgress
            # reviewProgressTotal
            # selfReviewRating
            # leadReviewerRating
            # daysUntilDue
            #coachTarget {
            #  items {
            #    coachid
            #    appointedAsCreator
            #    coach {
            #      id
            #      firstName
            #      lastName
            #      profileImage {
            #        fileName
            #      }
            #    }
            #  }
            #}
            notification {
              items {
                id
              }
            }
            #createdBy {
            #  firstName
            #  fullName
            #  lastName
            #  id
            #  profileImage {
            #    url
            #    fileName
            #  }
            #}
            # linkTarget {
            #   id
            #   title
            #   logo {
            #     url
            #     fileName
            #   }
            #   createdBy {
            #     firstName
            #     fullName
            #     lastName
            #     id
            #     profileImage {
            #       url
            #       fileName
            #     }
            #   }
            # }
            targetStatus
            # usersToRate
            title
            type
            createdAt
            companyId
            # publishDate
            dueDate
            id
            needDeletionApproval
            #userTargetForReview {
            #  id
            #  userForReview {
            #    firstName
            #    id
            #    lastName
            #    profileImage {
            #      url
            #      fileName
            #    }
            #  }
            #}
            userTargetStatusOfLoginUser {
              id
              status
              enableMarkCompletionRequest
              selfRating
              leadReviewerRating
            }
            #myTeamTargets {
            #  items {
            #    completionApprovalStatus
            #    completionFlowComments {
            #      comment
            #    }
            #    id
            #    userid
            #    userTargetStatus
            #    user {
            #      id
            #      firstName
            #      lastName
            #      profileImage {
            #        url
            #        fileName
            #      }
            #      status
            #    }
            #    reviewStatus
            #  }
            #}
            checkin {
              items {
                id
                # name
                # checkInType
                # combinedCheckInTypes
                # endDate
                # createdByUserId
                # checkinCoachId
                # checkinCoach {
                #   id
                #   firstName
                #   lastName
                #   profileImage {
                #     fileName
                #   }
                # }
                # usercheckin {
                #   items {
                #     id
                #     userid
                #     checkInStatus
                #     user {
                #       id
                #       firstName
                #       lastName
                #       profileImage {
                #         fileName
                #       }
                #     }
                #   }
                # }
                # allCheckinRaters {
                #   userid
                #   firstName
                #   lastName
                #   profileImage {
                #     fileName
                #   }
                # }
                #allCheckinRatees {
                #  userid
                #  firstName
                #  lastName
                #  profileImage {
                #    fileName
                #  }
                #}
              }
            }
            #targetObjective {
            #  items {
            #    id
            #    name
            #    objectiveUser {
            #      items {
            #        id
            #        status
            #        subStatus
            #        user {
            #          id
            #          firstName
            #          lastName
            #          profileImage {
            #            fileName
            #          }
            #        }
            #      }
            #    }
            #  }
            #}
            #targetUser {
            #  items {
            #    id
            #    userid
            #    user {
            #      id
            #      firstName
            #      lastName
            #      profileImage {
            #        fileName
            #      }
            #    }
            #  }
            #}
          }
          count
          nextToken
        }
      }
    }
  }
`;

export const listSuccessStoryCustom = gql`
  query listSuccessStoryCustom(
    $id: ID!
    $companyId: ID!
    $isPerformanceReview: Boolean
    $isArchived: Boolean
  ) {
    getUser(id: $id, userCompanyId: $companyId) {
      listSuccessStoryCustom(
        isPerformanceReview: $isPerformanceReview
        isArchived: $isArchived
      ) {
        createSuccessStory
        createPerformanceReview
        archivedSuccessStoriesCount
        items {
          id
          title
          status
          cycle
          type
          dateOfMeeting
          createdAt
          createdByUserId
          kpiSelectionOption
          createdBy {
            firstName
            fullName
            lastName
            profileImage {
              url
              fileName
            }
          }
          manager {
            firstName
            fullName
            lastName
            id
            profileImage {
              url
              fileName
            }
          }
          coachees {
            firstName
            lastName
            id
            profileImage {
              url
              fileName
            }
          }
          discussionPoints
          managerDiscussionPoints
          postMeetingNotesByCreator
          postMeetingNotesByCollaborator
          superviseeAcknowledgement
          managerAcknowledgement
          isPerformanceReview
          totalCochees
          createdAt
        }
      }
    }
  }
`;

export const visionUserProfileDetail = gql`
  query visionUserProfileDetail(
    $id: ID!
    $companyId: ID!
    $visionType: VisionListType
  ) {
    getUser(id: $id, userCompanyId: $companyId) {
      id
      listVisionCustom(visionListType: $visionType, userId: $id) {
        items {
          id
          title
          createdByUserId
          description
          enableComments
          endDate
          isCompanyVision
          startDate
          requireEndDate
          isNew
          logo {
            fileName
            key
            url
          }
          encouragementWords {
            items {
              id
              createdByUserId
              createdBy {
                lastName
                firstName
                profileImage {
                  url
                  fileName
                }
              }
              encouragementWord
              createdAt
            }
          }
          comments {
            items {
              id
              comment
              createdByUserId
              createdBy {
                lastName
                firstName
                profileImage {
                  url
                  fileName
                }
              }
              createdAt
            }
          }
          linkTarget {
            id
            title
            logo {
              url
              fileName
            }
            createdByUserId
            createdBy {
              firstName
              fullName
              lastName
              id
              profileImage {
                url
                fileName
              }
            }
          }
          visibilityOption
          visionCompanyId
          visionStatus
          visionUsers {
            items {
              id
              userId
            }
          }
          createdBy {
            id
            firstName
            lastName
            profileImage {
              url
              fileName
            }
          }
        }
      }
    }
  }
`;

export const metaData = gql`
  query metaData {
    listMetaData {
      items {
        metaType
        name
        value
      }
    }
  }
`;

export const getUserCommunicationNotification = gql`
  query getUserCommunicationNotification(
    $notificationFilter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
    $type: NotificationCategory
  ) {
    listNotifications(
      limit: $limit
      filter: $notificationFilter
      nextToken: $nextToken
      type:$type
    ) {
      nextToken
      count
      items {
        id
        visionId
        targetId
        isCommunicationNotification
        isVisionNotification
        userId
        user {
          id
          firstName
          firstName
          profileImage {
            url
            fileName
          }
        }
        companyId
        notificationType
        message {
          isPerformanceReview
          title
          description
          targetId
          targetType
          target {
            title
            logo {
              fileName
            }
            type
          }
          documentName
          parentMessageId
          grandParentMessageId
          gifUrl
          documentUrl
          objectId
          successStoryType
          successStoryTitle
          successStoryCreator
        }
        source
        Isread
        createdAt
        updatedAt
        isDeleted
        createdBy {
          id
          firstName
          lastName
          profileImage {
            url
            fileName
          }
        }
      }
    }
  }
`;

export const getUserVisionNotification = getUserCommunicationNotification;
export const getUserGeneralNotification = getUserCommunicationNotification;

export const getTargetNotification = gql`
  query getTargetNotification(
    $notificationFilter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(
      limit: $limit
      filter: $notificationFilter
      nextToken: $nextToken
    ) {
      nextToken
      items {
        id
        targetId
        isCommunicationNotification
        userId
        user {
          id
          firstName
          firstName
          profileImage {
            url
            fileName
          }
        }
        companyId
        notificationType
        message {
          title
          description
          targetId
          target {
            title
            type
          }
          documentName
          parentMessageId
          grandParentMessageId
          gifUrl
          documentUrl
          objectId
        }
        source
        Isread
        createdAt
        updatedAt
        isDeleted
        createdBy {
          firstName
          lastName
          profileImage {
            url
            fileName
          }
        }
      }
    }
  }
`;
